<template>
  <router-view />
  <SiteLoadingScreen v-if="envStore.loading || heldForNavigation" />
</template>

<script setup lang="ts">
import SiteLoadingScreen from '@/components/SiteLoadingScreen.vue';
import { heldForNavigation } from '@/lib/loadingScreen';
import useEnvStore from '@/store/modules/env';

const envStore = useEnvStore();
</script>
